<template>
  <!-- 拼多多二跳 -->
  <div ref="box" class="maxwidht">
    <div class="defaultImg" @click="submitCodeForm">
      <img :src="currentObj.link_img" alt="">
    </div>
    <div class="center">{{ currentObj.company_info }}</div>
    <!-- <div>clickid:{{$route.query.clickid}}</div>
    <div>creativeid:{{$route.query.creativeid}}</div>
    <div>creativetype:{{$route.query.creativetype}}</div>
    <div>adid:{{$route.query.adid}}</div>
    <div>{{decodeURIComponent(currentObj.mobile_url)}}</div> -->
    <div style="height: 95px;"></div>
    <div class="button" @click="submitCodeForm">
      点击查看详情
    </div>
  </div>
</template>

<script src="../utils/jquery.js"></script>
<script>
import { getPagePddInfo,submitCode} from "../utils/api"
import CryptoJS from "crypto-js";
export default {
  name: 'shadows',
  data() {
    return {
      currentObj:{},
      defaultImg: [],
    }
  },
  created() {
    this.getPageDetail()
  },
  mounted(){

  },
  methods: {
    //跳转拼多多并提交code
    submitCodeForm(){
      let params = {
        code_id:this.encrypt(this.currentObj.landing_page_info_code)
      }

      // let pdd_url =this.currentObj.mobile_url.replace('__CID__',this.$route.query.creativeid)
      // .replace('__CLICKID__',this.$route.query.adid)
      // .replace('__AID__',this.$route.query.clickid)
      // .replace('__CTYPE__',this.$route.query.creativetype)
      window.open(this.currentObj.schema_url)
      submitCode(params).then(res=>{

      })
    },
    //获取页面详情
    getPageDetail() {
      let codeId=this.$route.query.code_id
      let encryptCode = this.encrypt(codeId)
      if (encryptCode) {
        let param={
          code_id: encryptCode,
          pass:"false",
          dencrypt_time:this.encrypt((Date.parse(new Date())/1000).toString()),
          adid:this.$route.query.adid,
          creativeid:this.$route.query.creativeid,
          creativetype:this.$route.query.creativetype,
          clickid:this.$route.query.clickid,

        }
        getPagePddInfo(param).then(res => {
          this.currentObj = res.data
          document.title = this.currentObj.title
          // this.defaultImg = this.currentObj.picture_src.split(",")
        }, err => {
        })
      }
    },
    //获取url参数
    getRequestParam(key) {
      var url = window.location.href
      let pattern = /(\w+)=(\w+)/ig; //定义正则表达式
      let parames = {}; // 定义参数对象
      url.replace(pattern, ($, $1, $2) => {
        parames[$1] = $2;
      });
      return parames;
    },
    //加密
    encrypt(text) {
      var key = CryptoJS.enc.Utf8.parse('1463587320654321'); //为了避免补位，直接用16位的秘钥
      var iv = CryptoJS.enc.Utf8.parse('1758326540123456'); //16位初始向量
      var encrypted = CryptoJS.AES.encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    }
  }
}
</script>

<style scoped>
.maxwidht {
  max-width: 500px;
  margin: 0 auto;
}
.defaultImg,.defaultImg img {
  width: 100%;
  display: flex;
}
.center {
  text-align: center;
}
.button {
  max-width: 500px;
  width: 100%;
  line-height: 80px;
  position: fixed;
  bottom: 0;
  border: none;
  font-size: 20px;
  font-weight: bold;
  color: white;
  text-align: center;
  background-image: url('../assets/btn.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pinduoduo.vue